module.exports = __webpack_public_path__ + "img/masked_personal.755e2ea1.svg";